var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditsAdded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 53,
    viewBox: "0 0 96 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9517 29.7513V19.8904H43.0519L46.8656 28.4845L50.766 19.8904H52.8462V29.7513H51.4794L51.5594 20.9171L47.5723 29.7513H46.1522L42.2318 20.9171L42.3185 29.7513H40.9517Z",
    fill: "#326164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4502 0.268066C47.6615 0.268066 42.5102 3.01058 39.2207 7.26362C38.0138 8.19954 36.9273 9.28099 35.9964 10.4904C31.7685 13.7824 29.041 18.9112 29.041 24.6772C29.041 34.6035 37.1005 42.6629 47.0267 42.6629C52.7928 42.6629 57.9215 39.9355 61.2135 35.7075C62.423 34.7766 63.5044 33.6902 64.4403 32.4832C68.6934 29.1937 71.4359 24.0424 71.4359 18.2538C71.4359 8.32751 63.3764 0.268066 53.4502 0.268066ZM53.4502 1.55276C62.6814 1.55276 70.1512 9.02254 70.1512 18.2538C70.1512 21.9171 68.9694 25.2995 66.9696 28.0495C67.775 26.0071 68.2241 23.789 68.2241 21.4655C68.2241 11.5392 60.1647 3.4798 50.2384 3.4798C47.915 3.4798 45.6969 3.92894 43.6544 4.73438C46.4044 2.73458 49.7868 1.55276 53.4502 1.55276ZM50.2384 4.76449C59.4697 4.76449 66.9394 12.2343 66.9394 21.4655C66.9394 25.1289 65.7576 28.5112 63.7578 31.2613C64.5633 29.2213 65.0124 27.0007 65.0124 24.6772C65.0124 14.751 56.953 6.69153 47.0267 6.69153C44.7032 6.69153 42.4826 7.14067 40.4427 7.94611C43.1927 5.94631 46.5751 4.76449 50.2384 4.76449ZM47.0267 7.97622C56.2579 7.97622 63.7277 15.446 63.7277 24.6772C63.7277 33.9085 56.2579 41.3782 47.0267 41.3782C37.7955 41.3782 30.3257 33.9085 30.3257 24.6772C30.3257 15.446 37.7955 7.97622 47.0267 7.97622Z",
    fill: "#326164",
    stroke: "#326164",
    strokeWidth: 0.385408
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5996 30.0983V19.5385H43.2765L46.8665 27.6287L50.5382 19.5385H53.193V30.0983H51.1241L51.1923 22.5716L47.7954 30.0983H45.9223L42.5952 22.6008L42.6687 30.0983H40.5996ZM42.2292 20.9147L46.1496 29.7489H47.5697L51.5568 20.9147L51.4768 29.7489H52.8436V19.8879H50.7633L46.863 28.4821L43.0492 19.8879H40.949V29.7489H42.3158L42.2292 20.9147Z",
    fill: "#326164"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9966 47.3247C65.099 40.482 77.5876 25.9542 94.7219 22.5848",
    stroke: "#326164",
    strokeWidth: 1.6701,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15585 19.4601C14.899 21.3048 21.8282 27.9633 26.0939 36.3178",
    stroke: "#326164",
    strokeWidth: 1.6701,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54851 38.435C18.1171 37.8273 24.2755 41.8148 28.6829 47.4593",
    stroke: "#326164",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsAdded);
export default __webpack_public_path__ + "static/media/CreditsAdded.c5c60dd6987061598ce845fc6462ed8a.svg";
export { ForwardRef as ReactComponent };